module.exports = __webpack_public_path__ + "assets/img/31e983867aa68501907b376a82f08037.png";